import React, {Component} from 'react';
import './App.css';
import $ from 'jquery';


import {withTranslation, Trans} from "react-i18next";

import {Helmet} from "react-helmet";

class Career extends Component {
    constructor(props) {
        super(props);
        const { t } = this.props;


    }

    componentDidMount() {

    }


    render() {
        const {i18n, t} = this.props;

        return (
            <div>
                <Helmet>
                    <title>{i18n.exists('career.seo.title') ? t('career.seo.title') : "Agile CE"}</title>
                    <meta name="description" content={i18n.exists('career.seo.description') ? t('career.seo.description') : ""} />
                    <meta property="og:title" content={i18n.exists('career.seo.title') ? t('career.seo.title') : "Agile CE"} />
                    <meta property="og:description" content={i18n.exists('career.seo.description') ? t('career.seo.description') : ""} />
                </Helmet>

                <div className="container content fade-in-website clients" id="career">
                    <span>Do naší firmy hledáme nové členy týmu.</span>
                    <br/> <br/>
                    <h3>Hledáme:</h3>
                    <br/>
                    <h3>Statika / statičku – senior pozice</h3>
                    <span>Rádi potkáme zkušenější projektanty v oboru statiky pozemních staveb se zájmem o navrhování nosných
                    konstrukcí s použitím běžných materiálů.
                    VŠ vzdělání v oboru, zkušenost s navrhováním min. 3 roky (autorizace výhodou).</span>
                    <br/> <br/>
                    <h3>Statik / statička – junior pozice</h3>
                    <span>Vhodné pro mladé motivované projektanty v oboru statiky pozemních staveb se zájmem o navrhování nosných
                    konstrukcí s použitím běžných materiálů.
                    VŠ vzdělání v oboru a zkušenost s navrhováním výhodou, ale rádi dáme příležitost i čerstvým absolventům.</span>
                    <br/> <br/>
                    <h3>Projektant / projektantka</h3>
                    <span>V týmu uvítáme projektanty se zkušenostmi s tvorbou projektové dokumentace.
                    VŠ vzdělání není podmínkou.</span>

                    <br/> <br/>
                    <h3>BIM modelář / modelářka</h3>
                    <span>Hledáme konstruktéry se zkušenostmi s modelováním v softwaru Revit.
                    VŠ vzdělání v oboru není podmínkou.</span>
                    <br/> <br/>
                    <h3>Konstruktér / Konstruktérka výztuže</h3>
                    <span>Hledáme konstruktéry se zkušenostmi s tvorbou výkresů výztuže (používáme RECOC, rádi zaučíme).
                    VŠ vzdělání není podmínkou.</span>

                    <br/> <br/>
                    <h3>Nabízíme:</h3>
                    <ul>
                        <li>firemní benefity</li>
                        <li>příjemné pracovní prostředí</li>
                        <li>vzdělaný, přátelský a skvělý kolektiv</li>
                        <li>platové ohodnocení odpovídající odborné úrovni jedince a průběžně dosahovaným výsledkům</li>
                        <li>možnost podílet se na prestižních zakázkách</li>
                        <li>možnost osobního růstu</li>
                    </ul>
                    <h3>Očekáváme:</h3>
                    <ul>
                        <li>schopnost vypracovávat a vést projekty statiky napříč všemi projekčními fázemi u pozicí statik</li>
                        <li>loajálnost, stabilitu, nasazení – práce vás musí bavit</li>
                        <li>chuť na sobě průběžně pracovat a zapojit své znalosti do růstu celého týmu</li>
                        <li>znalost kreslících/modelovacích a výpočtových softwarů</li>
                    </ul>



                    <br/> <br/>
                    <span>V případě zájmu nás kontaktujte na adrese <a href={"mailto:info@agile-ce.cz"}>info@agile-ce.cz</a> se shrnutím Vašich dosavadních
                    zkušeností a vzdělání v oboru ve formě krátkého CV. Důležitá je pro nás osobní schůzka a prezentace
                    výsledků Vaší práce.</span>

                </div>
            </div>
        );
    }
}

export default withTranslation()(Career);
